/**
 * 
 * @param {string} input 
 */
function InputAsRgba(input) {
    const inputArray = input.substring(0,input.length-1).substring(5).split(',').map((value, index) => {
        const valAsInt = parseInt(value,10);
        if(isNaN(valAsInt)) {
            throw new Error("RGB NaN");
        }
        if(valAsInt < 0 || valAsInt > 255) {
            throw new Error("RGB out of range");
        }
        if(index<3){
            return valAsInt;
        }
        const alpha = parseFloat(value);
        if(isNaN(alpha)) {
            throw new Error("Alpha NaN");
        }
        if(alpha < 0 || alpha > 1) {
            throw new Error("Alpha out of range");
        }
        return alpha;
    });
    let r = inputArray[0].toString(16).toUpperCase();
    let g = inputArray[1].toString(16).toUpperCase();
    let b = inputArray[2].toString(16).toUpperCase();
    if (r.length < 2) {
        r = "0" + r;
    }
    if (g.length < 2) {
        g = "0" + g;
    }
    if (b.length < 2) {
        b = "0" + b;
    }
    return {
        rgb: "#"+r+g+b,
        alpha: inputArray[3]
    };
}

const InputAsRgbHex = (input) => ( {rgb: input, alpha: 1})

/**
 * Converts input to RRGGBB hex + alpha OR #RRGGBB + alpha = 1
 * @param {string} input color in form: rbga(r,g,b,a) OR #RRGGBB
 */
function PickerInput(input) {
    
    if(/^#[A-Fa-f0-9]{6}$/.test(input)) {
        return InputAsRgbHex(input);
    }
    else if(/^rgba\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*((0(\.\d*)?)|1\.*0*)\s*\)$/.test(input)) {
        return InputAsRgba(input);
    }
    else {
        throw new Error("Input in invalid form");
    }
}

export default PickerInput;